import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetAllOpenOffices = () => {
  return useQuery(
    ["GetAllOpenOffices", { isOfficeOpen: true }],
    searchOfficeSettings,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllOpenOffices;
